export default {
  'meta': {
    'langName': 'BULGARIAN',
    'lang': 'Български'
  },
  'title': 'ИЗТЕГЛЯНЕ НА ПРОДУКТ – ЕЛЕКТРИЧЕСКА ТРОТИНЕТКА SD500E ИЛИ MD500E на марката BTWIN',
  'description': 'Здравейте,\n\nЗакупили сте електрическа тротинетка марка BTWIN, модел SD500E или MD500E. Благодарим Ви за покупката и доверието!\n\nВашата безопасност е наш приоритет, затова Ви молим да прочетете внимателно информацията по-долу.\n\nВъпреки строгите процедури за контрол на качеството, установихме дефект, свързан с безопасността на електрическите тротинетки BTWIN SD500E и MD500E. При интензивна употреба е възможно да се появи пукнатина в зоната на съединяване между рамката и кормилната колона. Този дефект може да доведе до прекъсване на съединението и съответно до риск от падане на потребителя.\n\nМолим Ви да отговорите на следващите въпроси, за да можем да Ви предложим подходящо решение за обезопасяване за Вашия продукт.\n\nМолим да ни извините за причиненото неудобство и Ви благодарим за доверието!\n\n\nЕкипът на DECATHLON',
  'emailConfirmation': {
    'title': 'Потвърдете имейл адреса си и държавата, в която живеете:'
  },
  'fields': {
    'country': 'Държава',
    'address': 'Имейл',
    'email': 'Имейл',
    'phonePrefix': 'Код на страната',
    'phone': 'Телефонен номер',
    'validations': {
      'phoneOrEmail': 'Моля, въведете имейл адрес или телефонен номер',
      'email': 'Въведете валиден имейл адрес',
      'phone': 'Въведете валиден телефонен номер',
      'selectAddress': 'Моля, изберете пълен адрес от списъка (номер, улица и населено място).',
      'incompleteAddress': 'Адресът трябва да съдържа номер, име на улица и населено място. Въведете поне улица и номер, след което изберете предложение от списъка.'
    },
    'firstName': 'Фамилно име',
    'lastName': 'Собствено име',
    'deliveryAddress': 'Адрес ',
    'additionalAddress': 'Допълнение към адреса',
    'city': 'Град',
    'zip': 'Пощенски код',
    'readConfirmation': 'Декларирам, че предоставените от мен данни за контакт са точни, потвърждавам, че съм прочел(а) посочените условия и се съгласявам с тях.',
    'choose': 'Избери',
    'required': 'Задължително поле',
    'deliveryAddressHelp': 'Въведете улица и номер, след което изберете пълен адрес от списъка.',
    'streetOnlyHint': 'Добавете номер на улицата.'
  },
  'ownerCheck': {
    'title': 'Все още ли притежавате една или повече електрически тротинетки SD500E или MD500E на марката BTWIN?'
  },
  'yes': 'Да',
  'no': 'Не',
  'ownerChanged': {
    'title': 'Имате ли данни за контакт с настоящия собственик? ',
    'confirmation': 'Госпожо/Господине,\n\nБлагодарим Ви, че се включихте в тази процедура за управление на качеството.\n\nМолим да ни извините за причиненото неудобство и Ви благодарим за доверието!\n\nЕкипът на DECATHLON'
  },
  'recall': {
    'title': 'Моля, посочете броя на електрическите тротинетки SD500E и MD500E BTWIN , които притежавате.',
    'descriptionSd500': 'Електрическа тротинетка SD500E',
    'descriptionEmd500e': 'Електрическа тротинетка MD500E',
    'modelNumberHelp': 'Ще откриете номера на модела (SD500E или MD500E) от долната страна на Вашата тротинетка, както е показано по-долу.',
    'quantity': 'Количество',
    'confirmation': 'Благодарим Ви, че попълнихте този формуляр. Вашата заявка беше успешно регистрирана.\n\nЩе Ви уведомим в срок до 20 дни за датата, от която ще можете да извършите ремонта.\n\nУспешен ден,\n\nЕкипът на DECATHLON'
  },
  'repair': {
    'title': 'Ремонт с Ваше участие',
    'description': 'Молим Ви да преустановите използването на тротинетката.\n\nЩе Ви изпратим безплатен ремонтен комплект заедно с инструкции, за да обезопасите Вашата тротинетка. Комплектът позволява лесен и бърз за монтаж.\n\nСлед като ни предоставите необходимата информация, ще се свържем с Вас в срок до 20 дни, за да уточним кога ще бъде наличен Вашият комплект за ремонт. Уверяваме Ви, че ще положим всички усилия за съкращаване на този срок, за да Ви осигурим възможно най-добро обслужване.',
    'videoLink': 'Видео',
    'store': 'Инструкция',
    'kitLabel': 'Пълен ремонтен комплект',
    'docLabel': 'Инструкция за ремонт',
    'callToAction': 'Натиснете тук, за да получите безплатен ремонтен комплект.',
    'infoConfirmation': 'Моля, проверете данните си',
    'validateConfirmation': 'Потвърди',
    'backConfirmation': 'Назад'
  },
  'repairRequest': {
    'title': 'Моля, въведете следната информация, за да получите своя ремонтен комплект:'
  },
  'form': {
    'submit': 'Напред'
  },
  'status': 'Translation validated by COUNTRY'
} as const
